export default __webpack_public_path__ + "static/media/IntraNEXV2Beta-inferior.c51f0271.svg";